// extracted by mini-css-extract-plugin
export default {"iconContainer":"SkillIcons_iconContainer__4-JyN","icon":"SkillIcons_icon__FqBnR"};